import React from "react";
import ErrorView from "../../common/ErrorView";
function ConsentManagementErrorView() {
  return <ErrorView type="openBankingGenericRedirectError"></ErrorView>
}
export default ConsentManagementErrorView;
